import React, { useState, useEffect, useMemo } from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Autocomplete, Paper } from "@mui/material";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import Dialog from "@mui/material/Dialog";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

import { MyDomain } from "../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

// Custom theme to override MenuItem and Select styles
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#e5e5e5", // Change selected option background color to gray
            "&:hover": {
              backgroundColor: "#e5e5e5", // Keep the same color on hover
            },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: 0, // Remove left padding
          textAlign: "left", // Align text to the left
        },
      },
    },
  },
});

const StyledPaper = styled(Paper)({
  maxHeight: "300px", // Set maximum height for the dropdown
  overflowY: "auto", // Enable vertical scroll
});
export default function FeedBack() {
  const { t, i18n } = useTranslation();
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [AcceptTerms, setAcceptTerms] = useState(0);
  const [CheckAcceptTerms, setCheckAcceptTerms] = useState(false);

  const AcceptTermsFunc = (event) => {
    setAcceptTerms(event.target.checked ? 1 : 0);
    setCheckAcceptTerms(false);
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const [Department, setDepartment] = useState(t("profile.chooseadepartment"));
  const [CheckDepartment, setCheckDepartment] = useState(true);
  useEffect(() => {
    setDepartment(Department);
    console.log(Department);
  }, [Department]);

  const [FirstName, setFirstName] = useState(user?.FirstName);
  const [Email, setEmail] = useState(user?.Email);
  const [Subject, setSubject] = useState("");
  const [TheText, setTheText] = useState("");

  const CreateFeedBack = () => {
    const formattedDate = format(new Date(), "dd-MM-yyyy");
    const formattedTime = format(new Date(), "HH:mm");

    if (Department === t("profile.chooseadepartment")) {
      setCheckDepartment(false);
    } else {
      setCheckDepartment(true);
    }

    if (AcceptTerms === 1) {
      setCheckAcceptTerms(false);
    } else {
      setCheckAcceptTerms(true);
    }

    if (AcceptTerms === 1 && Department !== t("profile.chooseadepartment")) {
      const data = {
        UserId: user?.userId,
        Department: Department,
        Name: FirstName,
        Email: Email,
        Subject: Subject,
        MessageText: TheText,
        DateSend: formattedDate,
        TimeSend: formattedTime,
        IsRead: 0,
      };

      axios
        .post(`${MyDomain}FeedBack/CreateFeedBack`, data) // API URL for adding products to the cart
        .then((response) => {
          console.log(response.data);
          setOpenDone(true);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    }
  };
  const [openDone, setOpenDone] = useState(false);

  const handleClose2 = () => {
    setOpenDone(false);
  };
  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={openDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>{t("profile.successfullysent")}</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: MyWidth <= 1024 ? "90%" : "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    handleClose2();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Done")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }
  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 55px)",
        display: "flex",
        flexDirection: MyWidth <= 1024 ? "column" : "row",
        paddingTop: 50,
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      {ModalDone()}
      <div
        style={{
          //backgroundColor: "red",
          display: "flex",
          width: MyWidth <= 1024 ? "100%" : "50%",
          justifyContent: "center",
          //alignItems: "center",
          flexDirection: "column",
          paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
          paddingRight: MyWidth <= 1024 ? "2%" : "0%",
          direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
        }}
      >
        <a style={{ fontSize: 25, fontWeight: "600", paddingBottom: 20 }}>
          {t("profile.WEAREALWAYSINTOUCH")}
        </a>
        <a
          style={{
            opacity: 0.5,
            fontSize: 14,
            width: "80%",
            paddingBottom: 35,
          }}
        >
          {t("longTexts.Youcanalways")}
        </a>

        <a
          style={{
            fontWeight: "500",
            fontSize: 22,
            //direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
          }}
        >
          {i18n.resolvedLanguage === "en" ? (
            <>+972 52-747-7128</>
          ) : (
            <>52-747-7128 972+</>
          )}
        </a>
      </div>
      <div
        style={{
          backgroundColor: "",
          display: "flex",
          width: MyWidth <= 1024 ? "100%" : "50%",
          border: "0.2px solid #e4e4e7",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <ThemeProvider theme={theme}>
          <Box
            style={{
              paddingBottom: 30,
              width: MyWidth <= 1024 ? "90%" : "80%",
              fontSize: 10,
              paddingTop: 30,
            }}
          >
            <FormControl fullWidth>
              <Select
                labelId="custom-select-label"
                id="custom-select"
                value={Department} // Controlled by state
                onChange={(event) => setDepartment(event.target.value)} // Update state on change
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove default border
                    borderBottom:
                      CheckDepartment === false
                        ? "1px solid red"
                        : "1px solid #ccc", // Add a bottom line
                    borderRadius: 0, // Remove border radius for the input
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove border on hover
                    borderBottom: "1px solid #a1a1aa", // Darker bottom line on hover
                    borderRadius: 0, // Remove border radius on hover
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none", // Remove border when focused
                    borderBottom: "1px solid #a1a1aa", // Thicker bottom line when focused
                    borderRadius: 0, // Remove border radius when focused
                  },
                  "& .MuiSelect-select": {
                    paddingLeft: 0, // Remove left padding
                    textAlign: "left", // Align text to the left
                    fontSize: 14,
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #a1a1aa", // Add border to the dropdown list
                      borderRadius: 0, // Remove border radius for the dropdown list
                      boxShadow: "none", // Optional: Remove box shadow
                      fontSize: 14,
                    },
                  },
                }}
              >
                <MenuItem
                  style={{ fontSize: 14 }}
                  value={t("profile.chooseadepartment")} // Empty value for no selection
                  onClick={() => {
                    setDepartment(t("profile.chooseadepartment")); // Reset to no selection
                  }}
                >
                  {t("profile.chooseadepartment")}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: 14 }}
                  value={t("profile.partnership")}
                  onClick={() => {
                    setDepartment(t("profile.partnership"));
                  }}
                >
                  {t("profile.partnership")}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: 14 }}
                  value={t("profile.markiting")}
                  onClick={() => {
                    setDepartment(t("profile.markiting"));
                  }}
                >
                  {t("profile.markiting")}
                </MenuItem>
                <MenuItem
                  style={{ fontSize: 14 }}
                  value={t("profile.customerservice")}
                  onClick={() => {
                    setDepartment(t("profile.customerservice"));
                  }}
                >
                  {t("profile.customerservice")}
                </MenuItem>
              </Select>
            </FormControl>
          </Box>
        </ThemeProvider>
        <TextField
          id="standard-basic"
          label={t("profile.name")}
          variant="standard"
          style={{
            paddingBottom: 30,
            width: MyWidth <= 1024 ? "90%" : "80%",
            fontSize: 10,
          }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={FirstName}
          onChange={(e) => setFirstName(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
        <TextField
          id="standard-basic"
          label={t("profile.email")}
          variant="standard"
          style={{
            paddingBottom: 30,
            width: MyWidth <= 1024 ? "90%" : "80%",
            fontSize: 10,
          }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
        <TextField
          id="standard-basic"
          label={t("profile.Subject")}
          variant="standard"
          style={{
            paddingBottom: 30,
            width: MyWidth <= 1024 ? "90%" : "80%",
            fontSize: 10,
          }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          value={Subject}
          onChange={(e) => setSubject(e.target.value)}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
        />
        <TextField
          id="standard-multiline-static"
          label={t("profile.Messagetext")}
          multiline
          rows={4}
          //defaultValue="Default Value"
          variant="standard"
          style={{
            paddingBottom: 20,
            width: MyWidth <= 1024 ? "90%" : "80%",
            fontSize: 10,
          }}
          InputLabelProps={{
            style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
          }}
          sx={{
            "& .MuiInput-underline:before": {
              borderBottomColor: "#a1a1aa", // Default color for bottom line
              opacity: 0.5,
              borderBottomWidth: "1px", // Thin bottom line
            },
            "& .MuiInput-underline:hover:before": {
              borderBottomColor: "#a1a1aa", // Keep it gray on hover
              opacity: 0.8,
              borderBottomWidth: "1px", // Keep it thin on hover
            },
            "& .MuiInput-underline:after": {
              borderBottomColor: "#6366f1", // Change to yellow on focus
              borderBottomWidth: "1px", // Keep it thin when focused
            },
            "& .MuiInputBase-root": {
              //color: "#a1a1aa", // Color of the text in the input field
              fontSize: "14px", // Set font size of entered value to 14px
            },
          }}
          onChange={(e) => setTheText(e.target.value)} // Update state on input change
          value={TheText}
        />
        <a
          style={{
            display: "flex",
            margin: 0,
            justifyContent: "flex-start",
            alignItems: "flex-start",
            paddingTop: 10,
            paddingBottom: 50,
            fontSize: 14,
            width: MyWidth <= 1024 ? "90%" : "80%",
          }}
        >
          <Checkbox
            style={{
              paddingTop: 3,
            }}
            {...label}
            icon={
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  border: "1.4px solid black", // border for unchecked state
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 1,
                }}
              />
            } // Unchecked icon
            checkedIcon={
              <Box
                sx={{
                  width: 18,
                  height: 18,
                  border: "1.4px solid black", // border for checked state
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 1,
                }}
              >
                <Box
                  sx={{
                    width: 10, // smaller square inside
                    height: 10,
                    backgroundColor: "black", // color of the small square
                  }}
                />
              </Box>
            } // Checked icon with small square
            checked={AcceptTerms === 1}
            onChange={AcceptTermsFunc}
            sx={{
              padding: 0, // remove padding
            }}
          />
          <a
            style={{
              display: "flex",
              flexDirection: "column",
              color: CheckAcceptTerms === true ? "red" : "black",
            }}
          >
            <a>{t("longTexts.acceptTerms")}</a>
          </a>
        </a>
        <div
          style={{ width: "80%", display: "flex", justifyContent: "flex-end" }}
        >
          <button
            style={{
              marginTop: 20,
              backgroundColor: "#27272a",
              color: "#fff",
              border: "none",
              //padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "30%",
              minWidth: 180,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 50,
              marginBottom: MyWidth <= 1024 ? 10 : 0,
            }}
            onClick={() => {
              CreateFeedBack();
            }}
          >
            <a style={{ fontSize: 14 }}>{t("profile.Send")}</a>
          </button>
        </div>
      </div>
    </div>
  );
}
